type OrigemTipo = {
    codigo:number|EnumOrigemTipo;
    nome:string;
    dataCriacao:Date;
    ativo:boolean;
}
export enum EnumOrigemTipo {
    Avulso = 1,
    Viagem = 2,
    Inscricao = 3
}
export default OrigemTipo;